import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 26 26"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": "1.583",
      d: "M2 6.056C2 5.473 2.473 5 3.056 5h8.937c.352 0 .68.175.876.467l1.54 2.289c.196.291.524.466.875.466h4.66c.583 0 1.056.473 1.056 1.056v13.666c0 .583-.473 1.056-1.056 1.056H3.056A1.056 1.056 0 0 1 2 22.944z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": "1.583",
      d: "M5.969 13.138c.152-.417.548-.694.991-.694h16.753c.733 0 1.243.73.991 1.418l-3.45 9.445a1.055 1.055 0 0 1-.992.693H3.509c-.733 0-1.243-.73-.99-1.418z"
    }, null, -1)
  ]))]))
}
export default { render: render }